import axios from "axios";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { GlobalContext } from "../../context/GlobalContext";
import { useNavigate, useParams } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";
import { Modal, Button } from "react-bootstrap";
import { TiPlus, TiDelete } from "react-icons/ti";
import kategori from "../../kategori.json";

const EditProductPage = () => {
  let { id } = useParams();
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showModal, setShow] = useState(false);
  const [arrayField, setArrayField] = useState([]);
  const [fieldInput, setFieldInput] = useState("");
  const [objField, setObjField] = useState({});
  const { contextState, contextFunctions } = useContext(GlobalContext);
  const {
    inputProduct,
    setInputProduct,
    progress,
    preview,
    fetchStatus,
    setFetchStatus,
  } = contextState;
  const { handleChangeInputProduk, onImageChange, handleSubmitProduk } =
    contextFunctions;
  const renderFieldName = (str) => {
    var i,
      frags = str.split("_");
    for (i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(" ");
  };

  const handleChangeEditInputProduk = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    setObjField({ ...objField, [name]: value });
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleChangeField = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    setFieldInput(value.split(" ").join("_").toLowerCase());
  };

  const submitField = (event) => {
    event.preventDefault();
    axios
      .post(`https://productspec.cyclic.app/form_field/`, {
        field: fieldInput,
      })
      .then((res) => {
        const tempObj = {};
        tempObj[fieldInput] = "";
        setInputProduct({ ...inputProduct, ...tempObj });
        setFieldInput("");
        setShow(false);
      });
  };

  const fieldArray = useMemo(() => {}, []);

  const inputFieldSetter = () => {
    if (arrayField !== undefined) {
      const tempObj = {};
      arrayField.forEach((el) => {
        tempObj[el.field] = "";
      });
      return tempObj;
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const arrField = await axios.get(
        `https://productspec.cyclic.app/form_field/`
      );

      const res = await axios.get(
        `https://productspec.cyclic.app/product/${id}`
      );

      const tempObj = {};
      await arrField.data.forEach((el) => {
        tempObj[el.field] = "";
      });
      const objMerged = Object.assign(inputProduct, tempObj);

      for (let prop in objMerged) {
        if (res.data[prop] == undefined) {
          objMerged[prop] = "";
        } else {
          objMerged[prop] = res.data[prop];
        }
      }
      setObjField(objMerged);
      setLoading(false);
    })();
  }, []);

  const handleSubmitEditProduct = (event) => {
    event.preventDefault();
    axios
      .put(`https://productspec.cyclic.app/product/${id}`, objField)
      .then((response) => {
        setObjField({});
        setFetchStatus(true);
        navigate(`/products/${id}`);
      });
  };

  if (loading) {
    return <p className="loading"></p>;
  }

  const renderForm = (key, value) => {
    if (key == "jenis_produk") {
      return (
        <div className=" col-md-4 input-form" key={key}>
          <label htmlFor="jenis_produk" className="form-label">
            Jenis Produk
          </label>
          <select
            name="jenis_produk"
            onChange={handleChangeEditInputProduk}
            className="form-select"
            value={value}
          >
            {kategori.map((e, key) => {
              return (
                <option key={key} value={e}>
                  {e}
                </option>
              );
            })}
          </select>
        </div>
      );
    } else {
      return (
        <div className=" col-md-4 input-form" key={key}>
          <label htmlFor={key} className="form-label">
            {renderFieldName(key)}
          </label>
          <input
            type="text"
            className="form-control"
            id={key}
            onChange={handleChangeEditInputProduk}
            value={value}
            name={key}
            placeholder={key}
          />
        </div>
      );
    }
  };

  return (
    <div className="home page-add container-fluid">
      <div className="container">
        <h2 className="text-center fw-bold"> Edit Data Produk</h2>
        <form
          onSubmit={handleSubmitEditProduct}
          className="row g-3 form-border mt-4"
        >
          {objField !== undefined ? (
            Object.entries(objField).map(([key, value]) =>
              renderForm(key, value)
            )
          ) : (
            <p>null</p>
          )}

          <button
            type="submit"
            className="ButtonForm btn btn-primary mt-4 fw-bold rounded-pill"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditProductPage;
